<script>
  import { getClass, validateWidth } from './utils'

  export let width = 12
  export let widthMiddle = width
  export let widthWide = widthMiddle

  validateWidth(width)
  validateWidth(widthMiddle)
  validateWidth(widthWide)

  $: className = getClass({ width, widthMiddle, widthWide, className: $$props.class || '' })
</script>

<div {...$$restProps} class={className} on:click>
  <slot />
</div>
